import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AlertService } from '../vqutils/vq-alert/vq-alert.component';
import { ApiService } from '../services/api.service';
import { ModalService } from '../vqutils/vq-modal/vq-modal.component';

@Component({
  selector: 'app-post',
  templateUrl: './post.component.html',
  styles: []
})
export class PostComponent implements OnInit {

  @ViewChild('inputPhotos') inputPhotos: ElementRef;
  @ViewChild('inputFiles') inputFiles: ElementRef;

  post: any = {};
  postUpdate: any = {};
  files: any = [];
  photos: any = [];
  errors: any = {};
  isLoading: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private _router: Router,
    private _as: AlertService,
    private _api: ApiService,
    private _ms: ModalService,
  ) { }

  ngOnInit() {
    this.route.params.subscribe(
      params => {
        if (params['id']) {
          this.post.space = params['id'];
        }
        if (params['post']) {
          this.post.id = params['post'];
          this._api.posts
            .retrieve(this.post.id)
            .subscribe(
              (data) => {
                this.post = data;
              },
              (errors) => {
              });
        }
      });
  }

  fileChange(event, field) {
    this[field] = event.srcElement.files;
  }

  updateField(field, event) {
    this.postUpdate[field] = event;
  }

  deletePhoto(id) {
    this._api.postphotos
      .destroy(id)
      .subscribe(
        (data) => {
          this._as.success('La photo a été supprimée');
          this.post.photos = this.post.photos.filter(o => o.id != id);
        },
        (errors) => {
          this._as.danger('Des erreurs empêchent la suppression de la photo');
        });
  }

  deleteFile(id) {
    this._api.postfiles
      .destroy(id)
      .subscribe(
        (data) => {
          this._as.success('Le document a été supprimé');
          this.post.files = this.post.files.filter(o => o.id != id);
        },
        (errors) => {
          this._as.danger('Des erreurs empêchent la suppression du document');
        });
  }

  private _delete() {
    this._api.posts
      .destroy(this.post.id)
      .subscribe(
        (data) => {
          this._as.success('L\'actualité a été supprimée');
          this._router.navigate(['/', 'chantiers', this.post.space, 'posts']);
        },
        (errors) => {
          this._as.danger('Des erreurs empêchent la suppression de l\'actualité');
        });
  }

  delete() {
    this._ms.delete({
      confirm: () => this._delete()
    });
  }

  submit() {
    this.isLoading = true;
    if (this.post.id) {
      console.log(this.postUpdate);
      const formData = Object.keys(this.postUpdate).reduce((fd, key) => {
        fd.append(key, this.postUpdate[key]);
        return fd;
      }, new FormData());
      this._api.posts
        .partialUpdate(this.post.id, formData, {}, true)
        .subscribe(
          (data) => {
            this._as.success('L\'actualité a été mise à jour');
            this.post = data;
            let counter = 0;
            if (this.photos.length) {
              console.log(this.photos);
              Array.from(this.photos).forEach((photo, index) => {
                const fd = new FormData();
                fd.append('document', this.post.id);
                fd.append('photo', this.photos[index]);
                this._api.postphotos
                  .create(fd, {}, true)
                  .subscribe(
                    () => {
                      this.post.photos.push(data);
                      if (index >= (this.photos.length - 1)) {
                        this.photos = {};
                        this.inputPhotos.nativeElement.value = '';
                        counter++;
                        if (counter >= 2) {
                          this.isLoading = false;
                          this._router.navigate(['/', 'chantiers', this.post.space, 'posts']);
                        }
                      }
                    },
                    (errors) => { this.isLoading = false; });
              });
            } else {
              counter++;
              if (counter >= 2) {
                this.isLoading = false;
                this._router.navigate(['/', 'chantiers', this.post.space, 'posts']);
              }
            }

            if (this.files.length) {
              Array.from(this.files).forEach((file, index) => {
                const fd = new FormData();
                fd.append('document', this.post.id);
                fd.append('file', this.files[index]);
                this._api.postfiles
                  .create(fd, {}, true)
                  .subscribe(
                    (data) => {
                      this.post.files.push(data);
                      if (index >= (this.files.length - 1)) {
                        this.files = {};
                        this.inputFiles.nativeElement.value = '';
                        counter++;
                        if (counter >= 2) {
                          this.isLoading = false;
                          this._router.navigate(['/', 'chantiers', this.post.space, 'posts']);
                        }
                      }
                    },
                    (errors) => { this.isLoading = false; })
              });
            } else {
              counter++;
              if (counter >= 2) {
                this.isLoading = false;
                this._router.navigate(['/', 'chantiers', this.post.space, 'posts']);
              }
            }
          },
          (errors) => {
            this.isLoading = false;
            this.errors = errors;
            this._as.danger('Des erreurs empêchent la création de l\'actualité')
          }
        );
    } else {
      const formData = Object.keys(this.post).reduce((fd, key) => {
        fd.append(key, this.post[key]);
        return fd;
      }, new FormData());
      this._api.posts
        .create(formData, {}, true)
        .subscribe(
          (data) => {
            this._as.success('L\'actualité a été créé');
            this.post = data;
            let counter = 0;
            if (this.photos.length) {
              Array.from(this.photos).forEach((photo, index) => {
                const fd = new FormData();
                fd.append('document', this.post.id);
                fd.append('photo', this.photos[index]);
                this._api.postphotos
                  .create(fd, {}, true)
                  .subscribe(
                    (data) => {
                      this.post.photos.push(data);
                      if (index >= (this.photos.length - 1)) {
                        this.photos = {};
                        this.inputPhotos.nativeElement.value = '';
                        counter++;
                        if (counter >= 2) {
                          this.isLoading = false;
                          this._router.navigate(['/', 'chantiers', this.post.space, 'posts']);
                        }
                      }
                    },
                    (errors) => {
                      this._as.danger('Des erreurs empêchent la création de l\'actualité');
                      this.isLoading = false;
                    }
                  )
              });
            } else {
              counter++;
              if (counter >= 2) {
                this.isLoading = false;
                this._router.navigate(['/', 'chantiers', this.post.space, 'posts']);
              }
            }

            if (this.files.length) {
              Array.from(this.files).forEach((file, index) => {
                const formData = new FormData();
                formData.append('document', this.post.id);
                formData.append('file', this.files[index]);
                this._api.postfiles
                  .create(formData, {}, true)
                  .subscribe(
                    (data) => {
                      this.post.files.push(data);
                      if (index >= (this.files.length - 1)) {
                        this.files = {};
                        this.inputFiles.nativeElement.value = '';
                        counter++;
                        if (counter >= 2) {
                          this.isLoading = false;
                          this._router.navigate(['/', 'chantiers', this.post.space, 'posts']);
                        }
                      }
                    },
                    (errors) => { this.isLoading = false; }
                  )
              });
            } else {
              counter++;
              if (counter >= 2) {
                this.isLoading = false;
                this._router.navigate(['/', 'chantiers', this.post.space, 'posts']);
              }
            }
          },
          (errors) => { this.errors = errors; this.isLoading = false; }
        );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/post/post.component.ts